export const COMPANY_NAME = 'OneTrust';
export const TAGLINE_PST = 'Privacy, Security & Trust';
export const TAGLINE_PSG = 'Privacy, Security & Governance';
export const APP_TITLE = `${COMPANY_NAME} | ${TAGLINE_PSG}`;
